<template>
  <div class="col-md-12 text-center">    
    <Loader :show="store.state.creatingPage"/>
    <p class="loggedin-text mt-4">Signed in as {{ store.state.userLogon }}<br />not you? <a 
      class="stLogout primary-link" 
      @click="LogoutUser">Logout</a></p>
    <div class="row">
      <div class="col-md-6 m-auto">
        <button 
          id="btn-create" 
          :disabled="store.state.creatingPage || teamDetailsInValid()" 
          class="btn btn-block btn-driver" 
          @click="submitFormComplete">Create</button>
      </div>      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from '../inc/Loader.vue'
import store from "../../store/store";

export default {
  components: { 
    Loader
  },
  data() {
    return {
      store
    }
  },

  methods:{
    LogoutUser(){
      var vm = this;
      axios
        .get("/account/logoff?isPopUp=true", {
					headers: {
						"Content-Type": "application/json"
					},
				})
        .then(function (res) {
          if (res.data.success) {
            vm._onSuccessfulLogout();
          }
          else {
            this.$gfLogger.logInfo('logoff failed');
          }
        });
    },

    teamDetailsInValid: function() {
      if (this.store.state.pageType !== "createTeam")
        return false;
      return (this.store.state.details_team.teamTarget === '') || (this.store.state.details_team.teamName === '')
    },
    
    submitFormComplete(){
      this.$.appContext.config.globalProperties.emitter.emit('createFrp');
    },

    _onSuccessfulLogout: function() {
      this.store.commit('preUserLogin', '');
    }
  }
}
</script>

<style>
.loggedin-text, .loggedin-text a{
  font-size: 16px;
}

#btn-create {
  font-size: 18px;
  background-color: #F57C33;
  color:#fff;
  border-radius: 20px;
}

</style>